/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * What went wrong with a forms request.
 */
export type FormErrorCode = (typeof FormErrorCode)[keyof typeof FormErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormErrorCode = {
  tableAlreadyHasForm: 'tableAlreadyHasForm',
  notFound: 'notFound',
  forbidden: 'forbidden',
  ownerOnly: 'ownerOnly',
  signInRequired: 'signInRequired',
  closed: 'closed',
  tableGone: 'tableGone',
  alreadyResponded: 'alreadyResponded',
  noResponse: 'noResponse',
  unknownQuestion: 'unknownQuestion',
  repeatedAnswer: 'repeatedAnswer',
  missingAnswer: 'missingAnswer',
  invalidAnswer: 'invalidAnswer',
  widgetMismatch: 'widgetMismatch',
  fileUploadNeedsSignIn: 'fileUploadNeedsSignIn',
  invalidLayout: 'invalidLayout',
  invalidName: 'invalidName',
  invalidSharing: 'invalidSharing',
  tallyHidden: 'tallyHidden',
  conflict: 'conflict',
  internal: 'internal',
} as const;
